var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const Send2 = (_a) => {
    var { color = '#89C900', width = 16, height = 16 } = _a, props = __rest(_a, ["color", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10.7601 1.97333L4.74008 3.97333C0.693412 5.32666 0.693412 7.53333 4.74008 8.88L6.52674 9.47333L7.12008 11.26C8.46674 15.3067 10.6801 15.3067 12.0267 11.26L14.0334 5.24666C14.9267 2.54666 13.4601 1.07333 10.7601 1.97333ZM10.9734 5.56L8.44008 8.10666C8.34008 8.20667 8.21341 8.25333 8.08674 8.25333C7.96008 8.25333 7.83341 8.20667 7.73341 8.10666C7.54008 7.91333 7.54008 7.59333 7.73341 7.4L10.2667 4.85333C10.4601 4.66 10.7801 4.66 10.9734 4.85333C11.1667 5.04666 11.1667 5.36666 10.9734 5.56Z", fill: color })));
};
export default Send2;
